(function () {
    'use strict';
    var m = angular.module('dao');
    m.factory('policyTemplatesConverter', ["$q", "modulesManager", function ($q, modulesManager) {
        return function (input, args) {
            var module = modulesManager.currentModule();
            var blacklist = [{
                    template_name: 'Show all mailboxes',
                    template_desc: 'All mailboxes in Office365 Emails'
                }];
            var orderlist = [{
                    order: '0',
                    template_name: 'Show recent emails',
                    template_desc: 'All emails in Office365 Emails - Last 2 days'
                }];
            input.data.rows = _(input.data.rows).chain().filter(function (row) {
                if (_(blacklist).findIndex(function (item) {
                        return row.template_name === item.template_name && row.template_desc === item.template_desc;
                    }) !== -1) {
                    return false;
                }
                return row.type !== 'entity_sectool' && (args.disableFilter || args.saas && row.policy.policy_desc.saas == args.saas || !args.saas && row.policy.policy_desc.saas == module);
            }).sortBy(function (row) {
                var topOrder = '1';
                var order = row.type == 'single_entity' ? '0' : '1';
                var found = _(orderlist).find(function (item) {
                    return row.template_name === item.template_name && row.template_desc === item.template_desc;
                });
                if (found) {
                    topOrder = found.order;
                }
                return topOrder + '-' + order + '-' + row.template_name;
            }).value();
            return $q.when(input);
        };
    }]);
}());